import angular from 'angular'
import directive from './directive'

export default angular
  .module('ellipsis.momentDateFormatter', [])
  .directive('momentDateFormatter', directive)
